module.exports = __webpack_public_path__ + "img/checkmark-white.90174453.svg";